/**
 * Local-only auth toggle for development.
 * Flip the trailing `false` to `true` on localhost to force a mock logged-in user.
 * Paste a raw user-cookie JSON string into `mockCookie`.
 * Do not commit with the mock flag enabled, and never paste real tokens into git.
 */
const isLocalHost =
    typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const useMockCookie = isLocalHost && false; // flip last flag locally only

/** Paste a raw user-cookie JSON string here when using local mock auth. */
export const mockCookie = '';
